import React, { useState } from "react";
import "../Css/career.css";
import ACSApplicationFrom from "../pdf/ACS-Application-Form.docx";
import { Link } from "react-router-dom";
import BannerImg from "../Img/Final-images/Career-banner-2.png";
function Careers() {
  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const jobs = [
    {
      title: "Senior Residential Care Worker",
      location: "Cannock, Staffordshire",
      reportsTo: "Deputy Manager / Registered Manager",
      hours: "150+ hours per month (flexible shift pattern)",

      about:
        "We are looking for a committed Senior Residential Care Worker to join our team and support the day-to-day running of our children’s home. You will lead shifts, support the staff  team and help create a safe, nurturing and structured environment for young people. The role focuses on safeguarding children, promoting their wellbeing and supporting them to achieve positive outcomes in education, health, independence and relationships.",

      responsibilities: [
        "Lead shifts and support Residential Care Workers on duty",
        "Safeguard and promote the welfare of children and young people",
        "Support the implementation of care plans, risk assessments and behaviour support strategies",
        "Act as a key worker for young people where required",
        "Maintain accurate records including daily logs and incident reports",
        "Work with social workers, schools and other professionals",
        "Ensure the home operates in line with Children’s Homes Regulations and safeguarding policies",
      ],

      requirements: [
        "Level 3 Diploma in Residential Childcare (or equivalent)",
        "Experience working in a children’s residential care setting",
        "Ability to lead shifts and support staff teams",
        "Strong safeguarding awareness and communication skills",
      ],

      benefits: [
        "Competitive salary based on experience",
        "Flexible shift patterns including long shifts",
        "Ongoing training and professional development",
        "Support to complete higher qualifications including Level 4 or Level 5 apprenticeships in residential childcare or leadership",
        "Opportunities for career progression within the organisation",
      ],

      important:
        "Please note we do not offer visa sponsorship for this role. Applicants must have the right to work in the UK.",
    },

    {
      title: "Residential Care Worker",
      location: "Cannock, Staffordshire",
      reportsTo:
        "Senior Residential Care Worker / Deputy Manager / Registered Manager",
      hours: "150+ hours per month (flexible shift pattern)",

      about:
        "We are looking for compassionate and motivated Residential Care Workers to join our team supporting children and young people in a residential home setting. You will help create a safe, supportive and structured environment where young people can develop confidence, independence and positive life skills.",

      responsibilities: [
        "Support the daily care and wellbeing of children and young people",
        "Follow care plans, risk assessments and behaviour support strategies",
        "Act as a key worker for young people where required",
        "Support education, activities, health appointments and family contact",
        "Maintain accurate records including daily logs and incident reports",
        "Work as part of a team to provide a safe and nurturing home environment",
      ],

      requirements: [
        "Level 3 Diploma in Residential Childcare (or willingness to work towards it)",
        "Experience working with children or young people (desirable)",
        "Strong communication and teamwork skills",
        "Commitment to safeguarding and promoting children’s wellbeing",
      ],

      benefits: [
        "Competitive salary based on experience",
        "Flexible shift patterns including long shifts",
        "Ongoing training and professional development",
        "Support to complete Level 3 Residential Childcare qualification and higher apprenticeships (Level 4 or Level 5)",
        "Career progression opportunities within the organisation",
      ],

      important:
        "Please note we do not offer visa sponsorship for this role. Applicants must have the right to work in the UK",
    },
  ];

  const handleOpen = (job) => {
    setSelectedJob(job);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);
  // ✅ Better mailto handler (more reliable)
  const handleEmailClick = () => {
    const subject = encodeURIComponent("Job Inquiry");
    const body = encodeURIComponent(
      "Hello Team,\n\nI am interested in your services.\n\nThanks & Regards",
    );

    window.location.href = `mailto:info@affinitychildrens.co.uk?subject=${subject}&body=${body}`;
  };

  return (
    <>
      {/* Banner */}

      <section className="Career-banne text-center mobile-view">
        <div>
          <img src={BannerImg} className="w-100" />
        </div>
        <div className="container mobile-view-none">
          <div className="breadcrumb-container" aria-label="Breadcrumb">
            <ul className="breadcrumbs">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li aria-current="page">Career</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Job Cards */}
      <section className="jobs-section py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Open Positions</h2>

          <div className="row g-4">
            {jobs.map((job, index) => (
              <div className="col-lg-6 col-md-6 col-12" key={index}>
                <div className="card job-card p-3 h-100 shadow-sm">
                  <h5>{job.title}</h5>
                  <p className="text-muted">{job.location}</p>

                  <p>{job.about.substring(0, 120)}...</p>

                  <ul className="job-points">
                    {job.responsibilities.slice(0, 2).map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>

                  <button
                    className="btn btn-outline-primary mt-2 view-apply-btn"
                    onClick={() => handleOpen(job)}
                  >
                    View & Apply
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div class="note-box ">
            <div className="row w-100">
              <div className="col-md-4">
                <a
                  href={ACSApplicationFrom}
                  download="ACS-Application-Form.docx"
                  className="btn view-apply-btn"
                >
                  DOWNLOAD YOUR APPLICATION FORM
                </a>
              </div>

              <div className="col-md-7">
                <p className="text-center w-100">
                  Once you’ve completed the downloaded form, please email it to:
                  <span
                    className="email-link"
                    onClick={handleEmailClick}
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                  >
                    <strong> info@affinitychildrens.co.uk </strong>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <div
          className="custom-modal-overlay"
          onClick={handleClose} // 👈 click outside = close
        >
          <div
            className="custom-modal"
            onClick={(e) => e.stopPropagation()} // 👈 prevent inside click
          >
            <button className="close-btn" onClick={handleClose}>
              ✖
            </button>

            <h4>{selectedJob.title}</h4>
            <p className="text-muted">{selectedJob.location}</p>

            <p>
              <strong>Reports To:</strong> {selectedJob.reportsTo}
            </p>
            <p>
              <strong>Hours:</strong> {selectedJob.hours}
            </p>

            <h6 className="mt-3">About the Role</h6>
            <p>{selectedJob.about}</p>

            <h6>Key Responsibilities</h6>
            <ul className="job-points">
              {selectedJob.responsibilities.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>

            <h6>Requirements</h6>
            <ul className="job-points">
              {selectedJob.requirements.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>

            <h6>Benefits</h6>
            <ul className="job-points">
              {selectedJob.benefits.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>

            <h6>Important Information</h6>
            <p>{selectedJob.important}</p>

            <a
              href={ACSApplicationFrom}
              download="ACS-Application-Form.docx"
              className="btn my-3 w-100 view-apply-btn"
            >
              DOWNLOAD APPLICATION FORM
            </a>
          </div>
        </div>
      )}
    </>
  );
}

export default Careers;
